import Slider from "react-slick";
import './slide.scss';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import image1 from './Slide/eng.jpeg';
import image2 from './Slide/Topografia.jpg';
import image3 from './Slide/Geologia.png';
import image4 from './Slide/Facilities.png';
import image5 from '../../assets/pictures/ore-sorting.jpeg';
import image6 from '../../assets/pictures/estrutura_metalica.jpg';

export default function Slide(){
    const image =  [ image1, image2, image3, image4, image5, image6 ]

    const settings = {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed:2500,
        fade: true,
        pauseOnHover: false,
    };

        return(
           <main>
            <div className="slider__wrapper">
                <Slider {...settings}>
                    <div className="slider__content">
                        <div className="slider__text" data-aos="fade-left" data-aos-duration="2500" >
                            <span>1</span>
                            <h3>Engenharia Civil</h3>
                            <p>Obras e serviços de engenharia de pequeno e médio porte.</p>
                        </div>

                        <figure className="slider__image">
                            <img src={image[5]} alt="Imagem 1" data-aos="fade-in" data-aos-duration="2500" />
                        </figure>
                    </div>
                    
                    <div className="slider__content">
                        <div className="slider__text">
                            <span>5</span>
                            <h3>Projeto Ore Sorting</h3>
                            <p>Projeto Ore Sorting! Iniciado em 2022, este projeto visa aprimorar a classificação de minério, com três plantas independentes - Britagem, Part Sorter e Preparação de Amostras.</p>
                        </div>

                        <figure className="slider__image">
                            <img src={image[4]} alt="Imagem 5"/>
                        </figure>
                    </div>

                    <div className="slider__content">
                        <div className="slider__text">
                            <span>2</span>
                            <h3>Topografia</h3>
                            <p>Levantamento planialtimétrico, levantamento, cadastral, picada expedita, picada com estação total.</p>
                        </div>

                        <figure className="slider__image">
                            <img src={image[1]} alt="Imagem 2"/>
                        </figure>
                    </div>
                    <div className="slider__content">
                        <div className="slider__text">
                            <span>3</span>
                            <h3>Geologia</h3>
                            <p>Fornecimento de equipe de apoio a Geologia, serviços com trado manual e mecanizado, serviços de amostragem de solo e sedimento de corrente.</p>
                        </div>

                        <figure className="slider__image">
                            <img src={image[2]} alt="Imagem 3"/>
                        </figure>
                    </div>
                    <div className="slider__content">
                        <div className="slider__text">
                            <span>4</span>
                            <h3>Facilities</h3>
                            <p>Gestão de alojamentos, limpeza e manutenção predial, limpeza e manutenção de áreas verdes, limpeza de manutenção de ETA e ETE, controle de pragas, vigilância, jardinagem.</p>
                        </div>

                        <figure className="slider__image">
                            <img src={image[3]} alt="Imagem 4"/>
                        </figure>
                    </div>
                </Slider>
            </div>
           </main> 
        )

}